import {Pipe, PipeTransform} from '@angular/core';
import {CollegeProfession} from '../components/college-info/college-info.component';

@Pipe({name: 'filterByProfessionName'})
export class FilterByProfessionName implements PipeTransform {

  transform(value: CollegeProfession[], professionName: string, knowledgeFieldId: number): CollegeProfession[] {
    if (knowledgeFieldId && canSearch(professionName, knowledgeFieldId)) {
      return value.filter(function (prof: CollegeProfession) {

        return searchByProfessionName(professionName, prof) && searchByKnowledgeFieldSelectValue(knowledgeFieldId, prof);

      });
    } else if (!knowledgeFieldId && canSearchByProfessionName(professionName)) {
      return value.filter(function (prof: CollegeProfession) {
        return searchByProfessionName(professionName, prof);
      });
    }
    return value;
  }
}

function canSearchByProfessionName(name: string) {
  return name != null && name.trim().length > 0;
}

function canSearchByKnowledgeFieldSelectValue(selectID: number) {
  return selectID > 0;
}

function canSearch(name: string, selectID: number) {
  return canSearchByProfessionName(name) || canSearchByKnowledgeFieldSelectValue(selectID);
}

function searchByProfessionName(name: string, prof: CollegeProfession) {
  if (canSearchByProfessionName(name)) {
    return prof.professionName.toLowerCase().indexOf(name.toLowerCase()) > -1;
  }
  return true;
}

function searchByKnowledgeFieldSelectValue(selectID: number, prof: CollegeProfession) {
  if (canSearchByKnowledgeFieldSelectValue(selectID)) {
    return prof.knowledgeFieldID === selectID;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/filter/by-profession-name.filter.ts